import React from 'react';
import { Spinner } from 'react-bootstrap';

/**
 * 加载中组件
 * @returns {JSX.Element} 返回加载中组件
 */
function Loading() {
    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">加载中...</span>
            </Spinner>
        </div>
    );
}

export default Loading;
